export default __webpack_public_path__ + "static/media/03.355fe2a9.png";